<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
        type="email"
        class="form-control"
        :id="inputId"
        :disabled="disabled"
        v-model="inputValue"
    />
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'

export default {
  name: 'OrganizationWebsiteInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputLabel: {
      default: 'Сайт'
    },

    inputName: {
      default: 'website'
    }
  },

  computed: {
    inputId() {
      return 'form-organization-website'
    }
  }
}
</script>
